module.exports = __webpack_public_path__ + "img/logotipo-dark.cfdbf277.svg";